import React from 'react'

// SSR stub for framer-motion — motion.X renders as plain <X> elements
const handler: ProxyHandler<Record<string, unknown>> = {
  get(_target, prop: string) {
    return React.forwardRef((props: any, ref: any) => {
      const {
        animate, initial, exit, variants, transition,
        whileInView, whileHover, whileTap, whileFocus, whileDrag,
        viewport, layout, layoutId, drag, dragConstraints,
        onAnimationStart, onAnimationComplete,
        ...htmlProps
      } = props
      return React.createElement(prop, { ...htmlProps, ref })
    })
  },
}

export const motion = new Proxy({} as any, handler)
export const m = motion
export function AnimatePresence({ children }: any) { return children }
export function LazyMotion({ children }: any) { return children }
export function MotionConfig({ children }: any) { return children }
export function LayoutGroup({ children }: any) { return children }
export function useInView() { return true }
export function useReducedMotion() { return false }
export function useAnimation() { return { start: () => Promise.resolve(), stop: () => {} } }
export function useMotionValue(val: any) { return { get: () => val, set: () => {}, on: () => () => {} } }
export function useTransform() { return { get: () => 0, set: () => {} } }
export function useScroll() { return { scrollY: { get: () => 0 }, scrollYProgress: { get: () => 0 } } }
export function useSpring(val: any) { return typeof val === 'number' ? { get: () => val } : val }
export function domAnimation() {}
export function domMax() {}
